import React from 'react';
import P from '@hero/ui-kit/typography/P';
import type { MarkUrl } from '../types';

const ENV_FIELDS = [
    ['Dev', 'url_dev'],
    ['Stg', 'url_stg'],
    ['Prod', 'url_prod']
] as const;

const MarkUrlList: React.FC<{ urls: MarkUrl[] }> = ({ urls }) => (
    <>
        {urls.map((url) => (
            <div key={url.id} style={{ marginBottom: '0.8rem' }}>
                <P noDefaultMargin size="small" strong>
                    {`{{${url.slug}}}`}
                </P>
                {ENV_FIELDS.every(([, field]) => !url[field]) && (
                    <P noDefaultMargin size="small" styles={{ color: 'var(--mark-warning)' }}>
                        No URLs set
                    </P>
                )}
                {ENV_FIELDS.map(([label, field]) =>
                    url[field] ? (
                        <P
                            key={field}
                            noDefaultMargin
                            size="small"
                            styles={{ wordBreak: 'break-all' }}
                        >
                            {label}: {url[field]}
                        </P>
                    ) : null
                )}
            </div>
        ))}
    </>
);

export default MarkUrlList;
